import { useState } from "react";
import { useEntity, EditDialog, Field } from "./components/crud";
import { ScheduleEditor } from "./components/ScheduleEditor";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Textarea } from "../../components/ui/textarea";
import { Pencil, Plus } from "lucide-react";

const BLANK = { name: "", description: "", image: "", email: "", phone: "", color: "#2C5563", capacity: 1, weekly_schedule: {}, special_days: [], active: true, sort: 0 };

export default function ProvidersPage() {
  const { items, save, remove } = useEntity("providers");
  const [draft, setDraft] = useState(null);
  const set = (k, v) => setDraft((d) => ({ ...d, [k]: v }));

  return (
    <div data-testid="admin-providers-page">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-semibold">Providers</h1>
        <Button data-testid="add-provider-btn" onClick={() => setDraft({ ...BLANK, sort: items.length + 1 })}>
          <Plus size={16} className="mr-1" /> Add provider
        </Button>
      </div>
      <div className="bg-white border rounded-lg divide-y">
        {items.map((p) => (
          <div key={p.id} className="flex items-center gap-4 px-4 py-3">
            <span className="w-3 h-3 rounded-full shrink-0" style={{ background: p.color }} />
            <div className="flex-1">
              <p className="font-medium text-sm">{p.name}</p>
              <p className="text-xs text-muted-foreground">Capacity {p.capacity} · {p.email}</p>
            </div>
            <Button variant="ghost" size="icon" data-testid={`edit-provider-${p.id}`} onClick={() => setDraft(p)}><Pencil size={14} /></Button>
          </div>
        ))}
      </div>

      {draft && (
        <EditDialog open title={draft.id ? "Edit provider" : "New provider"} onClose={() => setDraft(null)}
          onSave={async () => (await save(draft)) && setDraft(null)}>
          <Field label="Name"><Input data-testid="provider-name-input" value={draft.name} onChange={(e) => set("name", e.target.value)} /></Field>
          <Field label="Description"><Textarea value={draft.description} onChange={(e) => set("description", e.target.value)} /></Field>
          <div className="grid grid-cols-2 gap-4">
            <Field label="Email"><Input value={draft.email} onChange={(e) => set("email", e.target.value)} /></Field>
            <Field label="Phone"><Input value={draft.phone} onChange={(e) => set("phone", e.target.value)} /></Field>
          </div>
          <div className="grid grid-cols-3 gap-4">
            <Field label="Colour"><input type="color" value={draft.color} className="h-9 w-full border rounded" onChange={(e) => set("color", e.target.value)} /></Field>
            <Field label="Capacity"><Input data-testid="provider-capacity-input" type="number" value={draft.capacity} onChange={(e) => set("capacity", Number(e.target.value))} /></Field>
            <Field label="Sort"><Input type="number" value={draft.sort} onChange={(e) => set("sort", Number(e.target.value))} /></Field>
          </div>
          <Field label="Weekly schedule"><ScheduleEditor value={draft.weekly_schedule} onChange={(v) => set("weekly_schedule", v)} /></Field>
        </EditDialog>
      )}
    </div>
  );
}
